import { defineComponent as S, computed as d, openBlock as l, createBlock as h, resolveDynamicComponent as b, normalizeStyle as y, withCtx as x, createElementBlock as z } from "vue";
import { KUI_ICON_SIZE_50 as c } from "./kong-icons.es1628.js";
const N = ["aria-hidden"], u = '<path d="M6.3 19.25V5.25H11.825C12.9083 5.25 13.9083 5.58333 14.825 6.25C15.7417 6.91667 16.2 7.84167 16.2 9.025C16.2 9.875 16.0083 10.5292 15.625 10.9875C15.2417 11.4458 14.8833 11.775 14.55 11.975C14.9667 12.1583 15.4292 12.5 15.9375 13C16.4458 13.5 16.7 14.25 16.7 15.25C16.7 16.7333 16.1583 17.7708 15.075 18.3625C13.9917 18.9542 12.975 19.25 12.025 19.25H6.3ZM9.325 16.45H11.925C12.725 16.45 13.2125 16.2458 13.3875 15.8375C13.5625 15.4292 13.65 15.1333 13.65 14.95C13.65 14.7667 13.5625 14.4708 13.3875 14.0625C13.2125 13.6542 12.7 13.45 11.85 13.45H9.325V16.45ZM9.325 10.75H11.65C12.2 10.75 12.6 10.6083 12.85 10.325C13.1 10.0417 13.225 9.725 13.225 9.375C13.225 8.975 13.0833 8.65 12.8 8.4C12.5167 8.15 12.15 8.025 11.7 8.025H9.325V10.75Z" fill="currentColor"/>', q = /* @__PURE__ */ S({
  __name: "BoldIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: c,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (i) => {
        if (typeof i == "number" && i > 0)
          return !0;
        if (typeof i == "string") {
          const e = String(i).replace(/px/gi, ""), r = Number(e);
          if (r && !isNaN(r) && Number.isInteger(r) && r > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(i) {
    const e = i, r = d(() => {
      if (typeof e.size == "number" && e.size > 0)
        return `${e.size}px`;
      if (typeof e.size == "string") {
        const n = String(e.size).replace(/px/gi, ""), t = Number(n);
        if (t && !isNaN(t) && Number.isInteger(t) && t > 0)
          return `${t}px`;
      }
      return c;
    }), g = d(() => ({
      boxSizing: "border-box",
      color: e.color,
      display: e.display,
      flexShrink: "0",
      height: r.value,
      lineHeight: "0",
      width: r.value,
      pointerEvents: e.decorative ? "none" : void 0
    })), p = (n) => {
      const t = {}, C = Math.random().toString(36).substring(2, 12);
      return n.replace(/id="([^"]+)"/g, (s, o) => {
        const a = `${C}-${o}`;
        return t[o] = a, `id="${a}"`;
      }).replace(/#([^\s^")]+)/g, (s, o) => t[o] ? `#${t[o]}` : s);
    }, f = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, m = (n) => n.replace(/[<>"'&]/g, (t) => f[t]), v = `${e.title ? `<title data-testid="kui-icon-svg-title">${m(e.title)}</title>` : ""}${e.staticIds ? u : p(u)}`;
    return (n, t) => (l(), h(b(i.as), {
      "aria-hidden": i.decorative ? "true" : void 0,
      class: "kui-icon bold-icon",
      "data-testid": "kui-icon-wrapper-bold-icon",
      style: y(g.value),
      tabindex: i.decorative ? "-1" : void 0
    }, {
      default: x(() => [
        (l(), z("svg", {
          "aria-hidden": i.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-bold-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: v
        }, null, 8, N))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
});
export {
  q as default
};
